import {
  BodyText,
  Button,
  Eyebrow,
  OptionList,
  Popover,
  Spinner,
  Stack,
} from '@servicetitan/design-system';
import { inboxLocators } from '@locators/inbox';
import strings from './strings';
import useAddressFormContext from '../../context/useAddressFormManagerContext';

interface SuggestedAddressProps {
  open: boolean;
  popoverTrigger?: React.ReactNode;
  showManualAddressEntry?: boolean;
  hideSuggestedAddress: () => void;
}

const SuggestedAddress = ({
  open,
  hideSuggestedAddress,
  popoverTrigger,
  showManualAddressEntry,
}: SuggestedAddressProps) => {
  const {
    handleSuggestedAddressClick,
    suggestedAddresses,
    loadingSuggestedAddresses,
    showFullForm,
  } = useAddressFormContext();

  const handleSuggestedAddressesMenuClick = (value: string) => {
    handleSuggestedAddressClick(value);
    hideSuggestedAddress();
  };

  const handleManualAddressEntryClick = () => {
    showFullForm();
    hideSuggestedAddress();
  };

  return (
    <Popover
      popoverContentClassName='p-x-1-i'
      open={open}
      header={
        <Eyebrow size='medium'>{strings.labels.suggestedAddressHeader}</Eyebrow>
      }
      footer={
        // only show the enter address manually button if the `showManualAddressEntry` prop is provided
        showManualAddressEntry ? (
          <Button
            primary
            id={
              inboxLocators.customerSearch.createFormFields.enterAddressManually
            }
            onClick={handleManualAddressEntryClick}
            size='xsmall'
            variant='text'
            width='full'
            fill='subtle'
          >
            {strings.labels.enterAddressManuallyButton}
          </Button>
        ) : undefined
      }
      trigger={popoverTrigger}
      direction='b'
      autoFlipVertically
      width='100'
      onClickOutside={hideSuggestedAddress}
    >
      {loadingSuggestedAddresses && (
        <Stack justifyContent='center'>
          <Spinner size='small' />
        </Stack>
      )}
      {suggestedAddresses && !loadingSuggestedAddresses && (
        <OptionList
          options={suggestedAddresses.map((suggestedAddress) => ({
            value: suggestedAddress.placeId,
            text: suggestedAddress.text,
          }))}
          onChange={(value) => handleSuggestedAddressesMenuClick(value)}
        />
      )}
      {suggestedAddresses.length === 0 && !loadingSuggestedAddresses && (
        <BodyText className='c-neutral-100 ta-center' size='small'>
          {strings.labels.noResults}
        </BodyText>
      )}
    </Popover>
  );
};

export default SuggestedAddress;
